module.exports = __webpack_public_path__ + "static/media/pias.4df32928.png";